import React, { useState } from "react";
import "../styles/uniforme.scss";

import radnaUniforma from "../images/radna.webp";
import kuvarUniforma from "../images/kuvar.webp";
import medicinaUniforma from "../images/medicina.webp";
import FAQ from "../components/Faq";
import UniformFeatures from "../components/UniformFeatures";

const uniformsData = [
  {
    title: "Medicinske uniforme",
    description:
      "Medicinske uniforme izrađene su od materijala koji pružaju udobnost tokom celodnevnog nošenja. Dostupne u različitim veličinama, bojama i stilovima, ove uniforme su prilagođene za doktore, medicinske sestre i ostalo medicinsko osoblje.",
    image: medicinaUniforma,
    features: [
      "Visok kvalitet materijala",
      "Otporne na habanje",
      "Dostupne različite boje i stilovi",
      "Jednostavne za održavanje"
    ]
  },
  {
    title: "Kuvarske uniforme",
    description:
      "Kuvarske uniforme obezbeđuju profesionalan izgled i maksimalan komfor u radnim uslovima u kuhinji. Dostupne su sa dodacima kao što su kecelje, kapice i prsluci.",
    image: kuvarUniforma,
    features: [
      "Otpornost na fleke",
      "Lagana i prozračna tkanina",
      "Moderne i klasične varijante",
      "Dizajnirane za maksimalnu fleksibilnost"
    ]
  },
  {
    title: "Radne uniforme",
    description:
      "Radne uniforme za industrijske radnike i tehničare pružaju zaštitu i udobnost tokom rada u teškim uslovima. Materijali su izdržljivi i prilagođeni za sve sektore rada.",
    image: radnaUniforma,
    features: [
      "Dodatna zaštita za ruke i noge",
      "Reflektivni elementi za rad u noćnim uslovima",
      "Otpornost na visoke temperature i pritiske",
      "Ergonomski dizajn"
    ]
  }
];

const UniformsDetailedPage = () => {
  const [selectedUniform, setSelectedUniform] = useState(null);

  const handleShowDetails = uniform => {
    setSelectedUniform(uniform);
  };

  const handleCloseDetails = () => {
    setSelectedUniform(null);
  };

  return (
    <div className="uniforms-detailed-page main-container">
      <h1 style={{ textAlign: "center" }} className="title">
        Naša Ponuda Uniformi
      </h1>
      <p className="page-description">
        Pružamo širok asortiman visokokvalitetnih uniformi za različite
        industrije, uključujući medicinske, kuvarske i radne uniforme.
        Prilagodite izbor prema vašim potrebama.
      </p>
      <div className="uniforms-grid">
        {uniformsData.map((uniform, index) =>
          <div className="uniform-card" key={index}>
            <img src={uniform.image} alt={uniform.title} />
            <div className="uniform-info">
              <h2>
                {uniform.title}
              </h2>
              <p>
                {uniform.description}
              </p>
              <button
                className="btn-primary"
                onClick={() => handleShowDetails(uniform)}
              >
                Saznajte više
              </button>
            </div>
          </div>
        )}
      </div>

      {selectedUniform &&
        <div className="uniform-details-modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseDetails}>
              &times;
            </button>
            <h2>
              {selectedUniform.title}
            </h2>
            <img src={selectedUniform.image} alt={selectedUniform.title} />
            <p>
              {selectedUniform.description}
            </p>
            <h3>Karakteristike:</h3>
            <ul>
              {selectedUniform.features.map((feature, index) =>
                <li key={index}>
                  {feature}
                </li>
              )}
            </ul>
          </div>
        </div>}

      <UniformFeatures />

      <FAQ />
    </div>
  );
};

export default UniformsDetailedPage;
